import ExternalLink from "components/ExternalLink/ExternalLink";
import TelegramIcon from "img/ic_telegram.svg?react";

export function FloatingTelegramButton() {
  return (
    <ExternalLink
      href="https://t.me/usdx_live"
      className="group fixed bottom-32 right-32 z-50 flex size-64 items-center justify-center rounded-full bg-gradient-to-br from-blue-400 to-blue-500 shadow-[0_4px_20px_rgba(93,189,183,0.4)] transition-all duration-300 hover:scale-110 hover:shadow-[0_6px_30px_rgba(93,189,183,0.6)] active:scale-95"
    >
      <TelegramIcon className="size-36 text-white transition-transform group-hover:scale-110" />
    </ExternalLink>
  );
}
